import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../commons/ServiceRequest";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import EditWorkOrderStatusForm from "../../../components/RepairWork/EditWorkOrderStatusForm";
import SeqRepairJobsService from "../../../services/seqrepairjob.service";

export default function EditRepairWorkOrders() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();

  useEffect(() => {
    handleChangeWebsiteTab({
      key: state?.name,
      setWebsiteName,
      tabNames: {
        create: "ออกใบสั่งงานแจ้งซ่อม",
        search: "แก้ไขสถานะใบสั่งงาน"
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Issue a repair work order Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          activeKey={state?.name}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="create" title="ออกใบสั่งงานแจ้งซ่อม"></Tab>
          <Tab eventKey="search" title="ข้อมูลใบสั่งงานแจ้งซ่อม">
            {websiteName === "แก้ไขสถานะใบสั่งงาน" && (
              <EditWorkOrderStatusForm
                onSubmitCallback={(data) =>
                  data.map(({ id, ...item }, idx) =>
                    addEditServiceRequest({
                      showAlert,
                      setLoading,
                      serviceRequest: SeqRepairJobsService.editSeqRepairJob(
                        id,
                        item
                      ),
                      navigated: (navi) =>
                        navi && idx === data?.length - 1 && navigate(0)
                    })
                  )
                }
              />
            )}
          </Tab>
          <Tab eventKey="request" title="ใบขอเบิกงานแจ้งซ่อม"></Tab>
        </Tabs>
      </Container>
    </>
  );
}
